import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

/**
 * Brand-aware toast container.
 * - `richColors` gives info/success/warning/error their own readable palettes
 *   (fixes the dark-on-dark "X subscribers will receive this" bar issue).
 * - We override the default toast surface with the Apex teal so it always
 *   reads cleanly against the cream/white admin pages.
 */
const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      richColors
      closeButton
      position="top-right"
      className="toaster group"
      toastOptions={{
        style: {
          background: "#004C54",
          color: "#ffffff",
          border: "1px solid rgba(255,255,255,0.18)",
        },
        classNames: {
          toast:
            "group toast !bg-[#004C54] !text-white !border-white/15 !shadow-2xl",
          title: "!text-white font-semibold",
          description: "!text-white/80",
          actionButton:
            "group-[.toast]:!bg-[#4FBCC7] group-[.toast]:!text-[#003a40] group-[.toast]:font-semibold",
          cancelButton:
            "group-[.toast]:!bg-white/10 group-[.toast]:!text-white",
          closeButton:
            "group-[.toast]:!bg-white/10 group-[.toast]:!text-white group-[.toast]:!border-white/20",
          success: "!bg-[#004C54] !text-white !border-white/15",
          info: "!bg-[#004C54] !text-white !border-white/15",
          warning: "!bg-[#B7791F] !text-white !border-white/15",
          error: "!bg-[#A23232] !text-white !border-white/15",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
